import React, { Component } from 'react';
import logService from '../services/LogService'
import { TestFieldItem } from '../components/TestFieldItem'
import { ErrorItemTable } from '../components/ErrorItemTable';

export class TestResult extends Component {
  static displayName = TestResult.name;

  constructor(props) {
    super(props);
    this.state = {
      immucertTestResult: null,
      loading: true,
      authorityId: props.location.query.authorityId,
      requestId: props.location.query.requestId,
      serverInstance: props.location.query.serverInstance,
      dataSource: props.location.query.dataSource
    };

    this.handleShowTestResult = this.handleShowTestResult.bind(this);
    this.handleDownloadCertificate = this.handleDownloadCertificate.bind(this);
  }

  componentDidMount() {
    this.setState({
      authorityId: this.props.location.query.authorityId,
      requestId: this.props.location.query.requestId,
      serverInstance: this.props.location.query.serverInstance,
      dataSource: this.props.location.query.dataSource
    });
    this.handleShowTestResult();
  }

  static renderTestResult(testResult) {
    return (
      <div>
        <h3>Form Dictionary Values</h3>
        <div>{Object.keys(testResult.content).map((key, index) => <TestFieldItem key={index} fieldKey={key} fieldValue={testResult.content[key]}/>)}</div>
        {testResult.errors !== null && testResult.errors.length > 0 &&
          <>
            <h3>Form Errors</h3>
            <div>{testResult.errors.map((item, index) => <TestFieldItem key={index} fieldKey={item.id} fieldValue={item.name}/>)}</div>
          </>
        }
        {testResult.conditionalVaccineGroups && testResult.conditionalVaccineGroups.length > 0 && 
          <>
            <h3>Conditional Vaccine Groups</h3>
            <div>{Object.keys(testResult.conditionalVaccineGroups).map((key, index) => <TestFieldItem key={index} fieldKey={key} fieldValue={testResult.conditionalVaccineGroups[key]}/>)}</div>
          </>
        }
      </div>
    );
  }

  static renderFaultResult(faultResult) {
    return (
      <div>
        <h3>Fault Response</h3>
        <ErrorItemTable errorItems={faultResult.issue} />
      </div>
    );
  }

  static renderTestId(id) {
    return (
      <div className="row">
        <div className="col-md-10 align-self-start font-weight-light">{id}</div>
      </div>
    );
  }

  render() {
    document.title = "Test:ImmucertUI";

    let contents = this.state.loading
      ? <p><em>Loading...</em></p>
      : this.state.immucertTestResult.requestId ? TestResult.renderTestResult(this.state.immucertTestResult)
      : TestResult.renderFaultResult(this.state.immucertTestResult);
    let idcontent = this.state.loading ? <p></p> : <div className="row"><div className="col-md-10 align-self-start font-weight-light">{this.state.immucertTestResult.id}</div><div className="col align-self-end"><button className="btn btn-primary" onClick={this.handleDownloadCertificate}>View Certificate</button></div></div>
    let idTestId = this.state.loading ? <p></p> : TestResult.renderTestId(this.state.immucertTestResult.id);
    return (
      <div>
        <h1 id="tabelLabel" >Immucert Test Request Results</h1>
        {idcontent}
        {idTestId}
        {contents}
      </div>
    );
  }

  handleDownloadCertificate() {
    console.log('Requesting certificate');
    logService.getCertificate(this.state.dataSource, this.state.serverInstance, this.state.authorityId, this.state.requestId);
  }

  handleShowTestResult() {
    console.log('Requesting test result');
    logService.getTestResult(this.state.dataSource, this.state.serverInstance, this.state.authorityId, this.state.requestId)
      .then(data => {
        if (data) {
          this.setState({ immucertTestResult: data, loading: false });
        }
      });
  }
}
